import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-up-icon',
  standalone: true,
  templateUrl: './chevron-up-icon.component.html',
})
export class ChevronUpIconComponent {}
